// P1D-5531. Near-me helpers taken out of NearMeOption and SearchListContainer.nearbyParams, so
// locate-me's "Search near me" and postcode search reuse the same URL and cookies.
// Import helpers and config by relative path: Jest here has no alias mapping.
import axios from "axios";
import config from "../config";
import getCookie from "../helpers/getCookie";
import setCookie from "../helpers/setCookie";

export type NearbyRegion = { canonical_name: string; name: string };
export type NearbyPoint = { lat: number; lng: number };

// Sets the 1-day `nearby_lat` / `nearby_lng` cookies, as NearMeOption always has.
export const setNearbyCookies = (lat: number, lng: number): void => {
  setCookie({ cname: "nearby_lat", cvalue: String(lat), exdays: 1 });
  setCookie({ cname: "nearby_lng", cvalue: String(lng), exdays: 1 });
};

// The existing `get_nearby_region` call. Null on no region or any error.
export const findNearestRegion = async (lat: number, lng: number): Promise<NearbyRegion | null> => {
  try {
    const { data } = await axios.get(`${config.API_URL}/api/v0/regions/get_nearby_region`, {
      params: { isNearbyPage: true, lat, lng },
    });
    const region = data?.data?.nearest_regions?.[0];
    return region?.canonical_name && region?.name
      ? { canonical_name: region.canonical_name, name: region.name }
      : null;
  } catch {
    return null;
  }
};

export const slugify = (name: string): string => name.toLowerCase().replace(/\s+/g, "-");

export const buildNearbyUrl = (canonicalName: string, slug: string): string =>
  `/places/search/${canonicalName}?locality=near-by-${slug}`;

// A near-by URL plus both cookies parsing as numbers → the point; otherwise undefined.
export const getNearbyPoint = (): NearbyPoint | undefined => {
  if (typeof window === "undefined") return undefined;
  const locality = new URLSearchParams(window.location.search).get("locality");
  if (!locality || !locality.includes("near-by")) return undefined;
  const lat = parseFloat(getCookie("nearby_lat") || "");
  const lng = parseFloat(getCookie("nearby_lng") || "");
  if (Number.isNaN(lat) || Number.isNaN(lng)) return undefined;
  return { lat, lng };
};
